import { render, staticRenderFns } from "./housingarrangement.vue?vue&type=template&id=88b14b40&scoped=true&"
import script from "./housingarrangement.vue?vue&type=script&lang=js&"
export * from "./housingarrangement.vue?vue&type=script&lang=js&"
import style0 from "./housingarrangement.vue?vue&type=style&index=0&id=88b14b40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b14b40",
  null
  
)

export default component.exports